/** One toast at a time (prototype): "Added to cart · Size M" with an optional "View cart" link. */
import { create } from 'zustand'

export interface ToastData {
  id: number
  message: string
  /** Show the "View cart" link. */
  viewCart?: boolean
}

interface ToastState {
  toast: ToastData | null
  show: (message: string, opts?: { viewCart?: boolean }) => void
  hide: () => void
}

let seq = 0

export const useToastStore = create<ToastState>()((set) => ({
  toast: null,
  show: (message, opts) => set({ toast: { id: ++seq, message, viewCart: opts?.viewCart } }),
  hide: () => set({ toast: null }),
}))

export const showToast = (message: string, opts?: { viewCart?: boolean }) =>
  useToastStore.getState().show(message, opts)
